import { AnimatePresence, motion } from 'framer-motion'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Button from '@/ui/Button'

import useCheckout from '../../hooks/useCheckout'

const {
  CheckoutStepWrapper,
  CheckoutStepTitle,
  CheckoutStepAction,
  CheckoutStepFooter,
  CheckoutStepContent
} = require('./CheckoutStep.styles')

const CheckoutStep = ({ title, action, t, children, fullwidth }) => {
  const navigate = useNavigate()
  const { currentStep, setCurrentStep } = useCheckout()
  const handleBack = () => {
    if (currentStep === 'PAYMENT') return setCurrentStep('CART')
    return navigate('/menu')
  }
  return (
    <CheckoutStepWrapper
      fullwidth={fullwidth}
      as={motion.div}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
    >
      {title && <CheckoutStepTitle>{title}</CheckoutStepTitle>}
      <CheckoutStepContent>{children}</CheckoutStepContent>
      {action && <CheckoutStepAction>{action}</CheckoutStepAction>}
      <CheckoutStepFooter>
        <AnimatePresence mode="wait">
          {!['SUMMARY', 'TERMINAL'].includes(currentStep) && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
              <Button variant="outline" onClick={handleBack}>
                {t('goBackToMenu')}
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </CheckoutStepFooter>
    </CheckoutStepWrapper>
  )
}

export default withTranslation()(CheckoutStep)
